import React from "react";
import { DappContextProvider } from "../../contexts/MintContext";
import { ConnectedWallet} from "./ConnectedWallet";
import { METAMASK_MISSING_MESSAGE } from "../../common/constants";

export function ConnectWallet(): React.ReactElement {
  const { isMetamaskInstalled, connectWallet, userAddress, setWarningMessage } = React.useContext(DappContextProvider);
  const isAddressDefined = userAddress !== undefined;

  function connectDisabledClick(): void {
    setWarningMessage("Install Metamask please.");
  }

  if(isAddressDefined){
    return(
      <ConnectedWallet address={userAddress}/>
    )
  }

  return (
    <div className="connect-wallet-button-wrapper"   
      title={ !isMetamaskInstalled ? METAMASK_MISSING_MESSAGE : "" } 
      onClick={ !isMetamaskInstalled ? connectDisabledClick : (): void => {/*noOp*/} }
    >
      <button
        disabled={ !isMetamaskInstalled }
        className="connect-wallet-button"
        type="button"
        onClick={connectWallet}
      >
        Connect
      </button>
    </div>
  );
}
